var config = {};
config.externalDependencies = {};
config.externalDependencies.kazooApiServerUrl = "https://lobbyapi.patlive.com/v1/";
config.externalDependencies.clientApiServerUrl = "https://flexapi.patlive.com/";
config.externalDependencies.webSocketServerUrl = "https://lobbysocket.patlive.com:443/";

config.isInDebugMode = true;
config.signupExpireTimeInMilliseconds = 1000 * 60 * 60 * 24 * 365;
config.environmentDomain = "localDebugging";
config.environmentHostName = "localDebugging";
config.frontendDomain = "patlive.com";
config.googleAnalyticsEnabled = "true";
config.googleAnalyticsTrackingId = "GTM-TDPSKD";
config.googleAdWordsConversionId = "0";
config.googleAdWordsConversionLabel = "";
config.awsS3BucketName = "patlive-patlive-prod01";

define("settings/environmentSettings", function(){});

